var modalTitles = {
    users: "PLANS.TOO_MANY_ACTIVE_USERS"
};
var Invite = /** @class */ (function () {
    function Invite($filter, Users, Toast, AmplitudeService, ModalService, LimitUsers, $location) {
        this.$filter = $filter;
        this.Users = Users;
        this.toast = Toast;
        this.amplitude = AmplitudeService;
        this.ModalService = ModalService;
        this.LimitUsers = LimitUsers;
        this.$location = $location;
        this.valid = false;
    }
    Invite.prototype.$onInit = function () {
        this.amplitude.logEvent('Panel:Users:Invite: Init');
        this.invitation = {};
        this.maxLimitUsersPlan = this.stats.usersCount + this.stats.pendingUsersCount;
    };
    Invite.prototype.invite = function () {
        var _this = this;
        this.Users.invite({}, { invitations: [this.invitation] }, function () {
            _this.amplitude.logEvent('Panel:Users:Invite: Sent');
            _this.toast.success('USERS.INVITATION_SENT');
            _this.$location.url('/users/all?newInvitation=true');
        }, function (error) {
            if (error.data.includes('USERS.LIMIT_REACHED')) {
                _this.showModalChangeUserLimit();
            }
        });
    };
    Object.defineProperty(Invite.prototype, "validForm", {
        get: function () {
            return this.invitation.email && this.invitation.roleId;
        },
        enumerable: true,
        configurable: true
    });
    Invite.prototype.getActiveUsersCount = function () {
        return this.users.filter(function (user) { return (user.state === 'ACTIVE' || user.state === 'PENDING'); }).length;
    };
    Invite.prototype.showModalChangeUserLimit = function () {
        var _this = this;
        this.amplitude.logEvent("Panel:Users:Invite: Error - users limit reached");
        this.ModalService.showPlanLimitUsersModal(modalTitles.users, '', this.users, this.maxLimitUsersPlan).then(function (response) {
            _this.amplitude.logEvent("Panel:Users:Invite: Number of users reduced");
            _this.users = _this.getActiveUsersCount();
            _this.LimitUsers.updateUsers(response);
            _this.toast.success();
        }, function () {
            _this.amplitude.logEvent("Panel:Users:Invite: Number of users not reduced");
            _this.setStartCountUser();
        });
    };
    Invite.$inject = ['$filter', 'Users', 'Toast', 'AmplitudeService', 'ModalService', 'LimitUsers', '$location'];
    return Invite;
}());
export default {
    controller: Invite,
    template: require('./users.invite.new.html'),
    bindings: { users: '<', stats: '<' }
};
